/* eslint-disable react/prop-types */
import { HeaderContainer as CarbonHeaderContainer } from '@carbon/react';

export const HeaderContainer = ({ children, ...props }) => (
  <CarbonHeaderContainer {...props}>{children}</CarbonHeaderContainer>
);
